import { Container, Flex, Heading } from '@chakra-ui/react';
import { graphql, navigate } from 'gatsby';
import React from 'react';
import Feed from '../../components/feeds/Feed';
import Layout from '../../components/layouts/Layout';
import SEO from '../../components/seo/SEO';

const ExperienceListPage = ({ data }) => {

    const { experiences: { nodes: experienceList } } = data

    const onFeedTapped = (slug: string) => {
        navigate(slug)
    }

    return <>
        <SEO title="Experiences - Vong Nyuk Soon" />
        <Layout>
            <Heading fontSize={'sm'} color={'gray.500'} pb={'4'} textTransform={'uppercase'}>Experiences</Heading>

            <Container maxW={'container.lg'} px={0}>
                <Flex flexFlow={'column'} mr={'auto'} maxW={{ base: 'full' }}>
                    {experienceList.map((exp) => <Feed props={{ mb: '4' }} feed={exp} onFeedTapped={onFeedTapped} />)}
                </Flex>
            </Container>
        </Layout>
    </>
};

export default ExperienceListPage;


export const expPageQuery = graphql`
  query ExperienceQuery {
    experiences: allMdx(
        filter: { frontmatter: { isLog: {eq: false } } },
        sort: { fields: [frontmatter___workDate], order: DESC}  
    ){
        nodes {
            excerpt(pruneLength: 120)
            id
            frontmatter {
                date(fromNow: true)
                title
                author
                workDate
                isLog
                tags
                place
                slug
            }
          }
    }
  }
`